import React, { useState, useRef, useEffect } from "react";
import './Aboutaward.css';


import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';

// Updated the variable name to awardsData
const img1 = 'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742214442/3_lbnz1f.jpg';
const video1 = 'https://res.cloudinary.com/dafd4nkgz/video/upload/v1742214456/WhatsApp_Video_2025-03-17_at_3.54.29_PM_skzpul.mp4';
const img3 =  'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742215333/WhatsApp_Image_2025-03-17_at_3.54.22_PM_a32qyw.jpg';
const img4 =  'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742214446/WhatsApp_Image_2025-03-17_at_3.54.21_PM_3_kf0m17.jpg';
const video2 =  'https://res.cloudinary.com/dafd4nkgz/video/upload/v1742274236/itoty_award_2024_online-video-cutter.com_1_vdyizt.mp4    ';
const img6 =  'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742214443/WhatsApp_Image_2025-03-17_at_3.54.22_PM_2_cvyp4l.jpg';
const img7 =  'https://res.cloudinary.com/dafd4nkgz/image/upload/v1742214444/WhatsApp_Image_2025-03-17_at_3.54.23_PM_c128le.jpg';
const tl = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742540820/btl_gx66l2.png";
const tr = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742540839/btr_yldzoa.png";
const bl = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742540863/bbl_lrytad.png";
const br = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742540884/bbr_vpojkl.png";
const trophy = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742539371/trophy_tgonwb.png";
const validated = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742540322/validated_dupnqc.png";

const cert = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743742770/01_1_q5w9df.jpg";
const cert2 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743742914/02_1_ikwtux.jpg";
const cert3 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748059/13_m7xpfv.png";
const cert4 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748060/12_c3fjrw.png";
const cert5 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748060/11_a7nasw.jpg";
const cert6 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748060/10_khewvm.jpg";
const cert7 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748061/07_1_qews3w.jpg";
const cert8 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748061/08_d8mysu.jpg";
const cert9 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748061/06_1_pybdqm.jpg";
const cert10 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748061/09_hfuum1.jpg";
const cert11 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748063/05_1_doglad.jpg";
const cert12 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748064/04_quektc.jpg";
const cert13 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748064/03_v2bjht.jpg";
const cert14 = "https://res.cloudinary.com/dafd4nkgz/image/upload/v1743748064/02_2_m89qpo.jpg";

const awardsData = [

    {
        year: "1999",
        description: "Company got Udyog Bhushan Award presented by Govt of India",
        tasvira: img1,
        isVideo: false
    },
    {
        year: "2010",
        description: "Got National Award from Govt of India",
        tasvira: video1,
        isVideo: true
    },
    {
        year: "2011",
        description: "Got Udyog Bharti Award presented by AIBCF.",
        tasvira: img3,
        isVideo: false
    },
    {
        year: "2013",
        description: "Got India Today Business Wizard Award.",
        tasvira: img4,
        isVideo: false
    },
    {
        year: "2022",
        description: "Got ITOTY Award for Best Super Seeder.",
        tasvira: video2,
        isVideo: true
    },
    {
        year: "2023",
        description: "Got ITOTY Award for Fastest Growing Implements Manufacturer.",
        tasvira: img6,
        isVideo: false
    },
    {
        year: "2024",
        description: "Got ITOTY Award for Best Rotavator.",
        tasvira: img7,
        isVideo: false
    }
];

const AboutAward = () => {

    const videoRefs = useRef([]);
    const [isMuted, setIsMuted] = useState(awardsData.map(() => true)); // Fixed the variable reference

    // Initialize refs dynamically using awardsData instead of awards
    useEffect(() => {
        videoRefs.current = awardsData.map(() => React.createRef());
    }, []);

    const toggleMute = (index) => {
        const updatedMuteState = [...isMuted];
        updatedMuteState[index] = !updatedMuteState[index];
        setIsMuted(updatedMuteState);

        if (videoRefs.current[index]?.current) {
            videoRefs.current[index].current.muted = updatedMuteState[index];
        }
    };

    return (
        <>
            <div className="awardheading">
                <h3 className="awardhl">AWARDS ARE MILESTONES</h3>
                <h3 className="awardhr">HEARTS ARE OUR DESTINATIONS</h3>
            </div>
            
            <div className="awardpositions">
                <p>National Award Winner</p>
                <div className="topleftcorner">
                    <img src={tl} alt="" />
                </div>
                <div className="toprightcorner">
                    <img src={tr} alt="" />
                </div>
                <div className="bottomleftcorner">
                    <img src={bl} alt="" />
                </div>
                <div className="bottomrightcorner">
                    <img src={br} alt="" />
                </div>
                <div className="bottomcenter">
                    <img src={trophy} alt="" />
                </div>
            </div>

            <div className="validated">
                <img src={validated} alt="" />
            </div>

            <div className="validatedtext">
                <h3>CERTIFICATION</h3>
                <p>Across India's vast lands, from Punjab's wheat fields to southern paddy fields and countless farms in between, DAMESH consistently delivers exceptional value every day. Our dedication to progressive farming is unwavering.</p>
                <p>Improving Indian farming practices is our greatest achievement; Global accolades and recognition are cherished bonuses.</p>
                <p>ISO certification and numerous awards fuel our passion. Empowered by these milestones, we'll continue innovating, Nurturing agricultural excellence and pioneering farming technologies.</p>
            </div>

            <div className="cont mt-4 mb-4">
                    <div className="custom-grid1">
                        <div className="item11">
                            <img src={cert} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert2} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert3} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert4} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert5} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert6} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert7} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert8} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert9} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert10} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert11} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert12} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert13} alt="" />
                        </div>
                        <div className="item11">
                            <img src={cert14} alt="" />
                        </div>
                    </div>
            </div>
            {/* design */}
            <div className="about-award-section">
                <h3>OUR AWARDS</h3>
            </div>
            <div className="timeline">
                <div className="milestone">
                    <div className="milestone-content">
                        <div className="row">
                            {awardsData.map((award, index) => (
                                <div className="col-lg-4 col-sm-6" key={index}>
                                    <div className="award-img-box">
                                        <div className="intersection-box">
                                            <div key={index} className="award-icons" style={{ position: 'relative' }}>
                                                {award.isVideo ? (
                                                    <>
                                                        <video
                                                            ref={videoRefs.current[index]}
                                                            autoPlay
                                                            loop
                                                            muted={isMuted[index]}
                                                            playsInline
                                                            className="award-icon"
                                                        >
                                                            <source src={award.tasvira} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </video>
                                                        <button
                                                            onClick={() => toggleMute(index)}
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: '10px',
                                                                right: '10px',
                                                                background: 'transparent',
                                                                border: 'none',
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            {isMuted[index] ? (
                                                                <VolumeOffIcon style={{ fontSize: '32px', color: 'white' }} />
                                                            ) : (
                                                                <VolumeUpIcon style={{ fontSize: '32px', color: 'white' }} />
                                                            )}
                                                        </button>
                                                    </>
                                                ) : (
                                                    <img src={award.tasvira} alt={`Award ${index}`} className="award-icon" />
                                                )}
                                            </div>
                                        </div>
                                        <h3 className="year-box">{award.year}</h3>
                                        <p className="award-text">{award.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AboutAward;
